export default __webpack_public_path__ + "static/img-personalised-recommendations-48b1d689162b75e422f4972282393cb3.png";